import { TextProps } from '@components/Text/Text';
import { CellTextText } from '@pages/Products/components/ListProducts/ListProducts.styles';

export const CellText = (props: TextProps) => {
  return <CellTextText text="p200" textColor="n900" {...props} />;
};
